export default __webpack_public_path__ + "img/cXaxgftL.36492b0a.svg";